import { render, staticRenderFns } from "./SalesTechnique.vue?vue&type=template&id=181bbee6&"
import script from "./SalesTechnique.vue?vue&type=script&lang=js&"
export * from "./SalesTechnique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports